module.exports = __webpack_public_path__ + "img/ysgj_017@2x.6cac3663.png";